// Entry point for module system
import Vue from 'vue'
import store from '@state/store'
// import router from '@router'
// import { PaladinCoreMiddleware } from '@paladin/core-middleware'
import { PaladinCore } from '@paladin/core'
import { PaladinCoreUI } from '@paladin/core-ui'
import { PaladinCoreAuth } from '@paladin/core-auth'
import { PaladinCoreBrowse } from '@paladin/core-browse'
import { PaladinCorePeople } from '@paladin/core-people'
import { PaladinCoreTenant } from '@paladin/core-tenant'
const { version } = require('../package.json')
const ModulesConfig = require('./modules.config.json')

let _config = ModulesConfig.tenants.find(function(tenant) {
  if (tenant) return tenant.hosts.includes(location.host)
})

if (!_config) throw Error('No module config found for host: ' + location.host)

const modules = [
  {
    plugin: PaladinCoreAuth,
    options: {
      store: store,
      authZero: {
        domain: _config.auth0.domain,
        clientID: _config.auth0.clientID,
        audience: _config.auth0.audience,
        redirectUri: origin + _config.auth0.redirectUri,
        responseType: _config.auth0.responseType,
        scope: _config.auth0.scope,
      },
      ms: {
        auth: {
          clientId: _config.ms.clientId,
          authority: _config.ms.authority,
          redirectUri: origin + '/callbackms',
          navigateToLoginRequestUrl: false
        },
      },
      callbackRouting: {
        successRoute: { name: 'dashboard' },
        newUserRoute: { name: 'settings-profile' },
        errorRoute: { name: 'dashboard' },
      },
      onCompleteCallback: () => {
        // store.dispatch('layout/displayLoadingScreen', false)
      },
    },
    // dependencies: {
    //   '@chirhos/chirhos-api': '^0.4.2',
    // }
  },
  {
    plugin: PaladinCore,
    options: {
      store: store,
      chirhos: {
        apiUrl: _config.chirhos.apiUrl,
      },
      onCompleteCallback: () => {
        // store.dispatch('layout/displayLoadingScreen', false)
      },
    },
  },
  {
    plugin: PaladinCoreUI,
    options: {
      store: store,
      appVersion: version,
    },
  },
  {
    plugin: PaladinCoreBrowse,
    options: { /* api: ChiRhos, */ store: store },
    // dependencies: {}
  },
  {
    plugin: PaladinCorePeople,
    options: { /* api: ChiRhos, */ store: store },
    // dependencies: {}
  },
  {
    plugin: PaladinCoreTenant,
    options: { /* api: ChiRhos, */ store: store },
    // dependencies: {}
  },
  // Always load PaladinCoreMiddleware last
  // {
  //   plugin: PaladinCoreMiddleware,
  //   options: {
  //     store: store,
  //     router: router, // move all store references and store init to PaladinCoreRouter module. Passing in store as well will alleviate the loading order issue.
  //   },
  // }
]

// console.log('Initialize Paladin Modules')
modules.forEach((module) => {
  module.options
    ? Vue.use(module.plugin, module.options)
    : Vue.use(module.plugin)
})

export default [
  PaladinCore,
  PaladinCoreUI,
  PaladinCoreAuth,
  PaladinCoreBrowse,
  PaladinCorePeople,
  PaladinCoreTenant,
]

// import config from './config'

// let modules = {
//   routes: [],
// }

// config.modules.forEach((module) => {
//   // console.log(module.src + '/index.js')
//   let _module = require(module.src + '/index.js')
//   if (_module.routes) {
//     modules.routes = modules.routes.concat(_module.routes)
//   }
// })

// export default modules

// const PaladinModulesPlugin = {
//   install(Vue, options) {
//     console.log('Initialized Paladin Modules Plugin')
//     // const {shortcodes, helpers} = options

//     // var routes = []

//     // console.log(config)
//     // config.modules.forEach((module) => {
//     //   // console.log(module.src + '/index.js')
//     //   let _module = require(module.src + '/index.js')
//     //   if (_module.routes) {
//     //     routes = _module.routes.map((item) => {
//     //       return {
//     //         component: item.component,
//     //         meta: item.meta,
//     //         name: item.name,
//     //         parent: item.parent,
//     //         path: item.path,
//     //       }
//     //     })
//     //   }
//     // })

//     // export module routes
//     // Vue.prototype.$moduleRoutes = function() {

//     // Object.defineProperty(Vue.prototype, '$moduleRoutes', { value: routes })
//     // }

//     // export module vuex stores

//     // not sure about the below yet
//     // define components (optional)
//     // define global methods (optional)
//     // define instance methods (optional)
//     // define mixins, directives, filters, etc. (optional)

//     // creates a instance method that can be used inside of a Vue component
//     // Vue.prototype.$parseContent = function(content) {
//     //   return helpers.parseContent(content, shortcodes)
//   },
// }

// export default PaladinModulesPlugin
